const { jobStatusType } = require('../../js/constants')
const {
  RequestRetryBackOffHelper
} = require('../../js/request-retry-backoff-helper')
angular
  .module('surfsightApp.controllers')
  .controller('reportsDashboardController', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    '$mdMedia',
    'edgeFactory',
    'edgeGroupFactory',
    'broadcastViewFactory',
    'leafletData',
    'leafletBoundsHelpers',
    'nominatimLookUp',
    'SystemConstants',
    'UnitSystem',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdSidenav,
      $mdToast,
      $mdColors,
      $mdMedia,
      edgeFactory,
      edgeGroupFactory,
      broadcastViewFactory,
      leafletData,
      leafletBoundsHelpers,
      nominatimLookUp,
      SystemConstants,
      UnitSystem,
      NgTableParams,
      $q
    ) {
      const pageLimit = window.groupSummaryReportPaginationLimit
      const groupId = parseInt($stateParams.edge_group_id)
      const deviceId = parseInt($stateParams.edge_id)
      const $translate = $filter('translate')
      let lastRequestQueryParams
      $scope.edge_name = ''
      const stateName = $state.current.name
      $scope.isMobile = $window.innerWidth <= 768
      $scope.UnitSystem = UnitSystem
      if ($localStorage.measurementUnits == 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
      const initTable = () => {
        $scope.ngSummaryReportTable = {
          columns: {
            dashcamName: {
              title: $translate('dashcamName')
            },
            distance: {
              title: `${$translate('distance')} - ${UnitSystem.value(
                1,
                'km',
                '$l'
              )}`
            },
            maxSpeed: {
              title:
                UnitSystem.current === 'imperial'
                  ? `${$translate('maxSpeed')} - mph`
                  : `${$translate('maxSpeed')} - km/h`
            },
            speedAlarms: {
              title: $translate('speedAlarms')
            },
            dangerousDrivingAlarms: {
              title: $translate('dangerousDrivingAlarms')
            },
            geoFenceAlarms: {
              title: $translate('geoFenceAlarms')
            }
          },
          ngTableParams: new NgTableParams(
            {
              noPager: true,
              page: 1, // show first page
              count: pageLimit // count per page
            },
            {
              counts: [],
              filterDelay: 300,
              getData: params => {
                return new Promise((resolve, reject) => {
                  ;(async () => {
                    if ($scope.groupDevicesState) {
                      $scope.groupDevicesState.page = params._params.page
                      $scope.groupDevicesState.limit = params._params.count
                    }
                    const {
                      tableRows,
                      totalRecords
                    } = await getEdgeReportsData()
                    params.total(totalRecords)
                    resolve(tableRows)
                  })()
                })
              }
            }
          )
        }
        $scope.reportName =
          (
            `${$scope.edge_name} ` +
            `${$translate('summaryReport')} ` +
            `(${$rootScope.reportDateRangeFilter.name_formate2}` +
            `${
              $rootScope.reportDateRangeFilter.current_year
                ? ' ' + $rootScope.reportDateRangeFilter.current_year
                : ''
            })`
          )
            .replace(/ {2}- /g, '-')
            .replace(/ {2}/g, ' ')
            .replace(/ /g, '-') + '.csv'
      }
      const initReport = () => {
        $timeout(() => {
          initTable()
        })
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#device-ui-settings-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      $scope.showSearchOption = () => !deviceId
      if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
          initReport()
        } else {
          const requestId = window.makeId(5)
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', {
            id: deviceId,
            requestId
          })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', (e, data) => {
            if (data.id === deviceId && data.requestId === requestId) {
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
              initReport()
            }
          })
        }
      } else if (
        [
          'home.common.reports.edgegroup',
          'home.common.reports.edgegroupreportDashboard'
        ].includes(stateName)
      ) {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
          initReport()
        } else {
          let group = edgeGroupFactory.list.find(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
            initReport()
          } else {
            const requestId = window.makeId(5)
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', {
              id: groupId,
              requestId
            })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', (e, data) => {
              if (data.id === groupId && data.requestId === requestId) {
                group = edgeGroupFactory.list.find(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
                initReport()
              }
            })
          }
        }
        $scope.groupDevicesState = {
          searchText: '',
          page: 1,
          limit: pageLimit,
          totalCount: 0,
          dashcam: []
        }
      }
      // mobile screens
      if (
        [
          'home.common.reports.edgegroupreportDashboard',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        if (!$rootScope.reportDateRangeFilter) {
          // page does not have search filter information. Redirect
          if (groupId) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: groupId
            })
          } else {
            $state.go('home.common.reports.edge', { edge_id: deviceId })
          }
        }
      }

      let searchTextTimer
      $scope.trackSearchText = () => {
        if (deviceId) return
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.groupDevicesState = {
            searchText: $scope.groupDevicesState.searchText,
            page: 1,
            limit: pageLimit,
            totalCount: 0,
            dashcam: []
          }
          $scope.ngSummaryReportTable.ngTableParams
            .parameters({ page: 1 })
            .reload()
        }, 1500)
      }
      $scope.analyticsTableState = {
        loading: false
      }
      $scope.$on('eventSearchDataResult', (e, data) => {
        $scope.ngSummaryReportTable.ngTableParams
          .parameters({ page: 1 })
          .reload()
      })
      $scope.showReportTable = (_deviceId, reportType) => {
        $scope.$emit('showReportTableEmit', {
          edge_id: _deviceId,
          reportType: reportType,
          eventSearch: $rootScope.reportDateRangeFilter
        })
        if (!$mdMedia('gt-sm')) {
          $state.go(
            'home.common.reports.edgereportDashboard',
            {
              edge_id: _deviceId,
              edge_group_id: groupId,
              eventSearch: $rootScope.reportDateRangeFilter,
              reportType: reportType
            },
            { reload: true, inherit: false, notify: true }
          )
        } else {
          $state.go(
            'home.common.reports.edge',
            {
              edge_id: _deviceId,
              eventSearch: $rootScope.reportDateRangeFilter,
              reportType: reportType
            },
            { reload: true }
          )
        }
      }
      const getEdgeReportsData = async () => {
        let tableRows = []
        let totalRecords
        const startTime = $rootScope.reportDateRangeFilter.date.start / 1000
        const endTime = $rootScope.reportDateRangeFilter.date.end / 1000
        const queryParams = new URLSearchParams()
        queryParams.append('startTime', startTime)
        queryParams.append('endTime', endTime)
        if (deviceId && $scope.edge) {
          const requestJson = {
            method: 'GET',
            url: `${EDGE_BASEURL}/device/${
              $scope.edge.uri
            }/summary-report?${queryParams.toString()}`
          }
          try {
            const deviceSummaryReportResponse = await $http(requestJson)
            const { deviceSummaryReport } = deviceSummaryReportResponse.data
            deviceSummaryReport.maxSpeed = getSpeed(
              deviceSummaryReport.maxSpeed
            )
            deviceSummaryReport.distance = getDistance(deviceSummaryReport)
            tableRows = [deviceSummaryReport]
            totalRecords = 1
          } catch (error) {
            handleServerError(error)
          }
        } else {
          const { page, limit, searchText } = $scope.groupDevicesState
          queryParams.append('searchText', searchText)
          queryParams.append('limit', limit)
          queryParams.append('page', page)
          lastRequestQueryParams = `${queryParams.toString()}&organizationId=${
            $rootScope.currentUserOrganization.id
          }&groupId=${groupId}`
          const requestJson = {
            method: 'GET',
            url: `${EDGE_BASEURL}/organization/${
              $rootScope.currentUserOrganization.id
            }/group/${groupId}/summary-report?${queryParams.toString()}`
          }
          try {
            const groupSummaryReportResponse = await $http(requestJson)
            const {
              groupSummaryReport,
              totalCount
            } = groupSummaryReportResponse.data
            groupSummaryReport.forEach(deviceSummaryReport => {
              deviceSummaryReport.maxSpeed = getSpeed(
                deviceSummaryReport.maxSpeed
              )
              deviceSummaryReport.distance = getDistance(deviceSummaryReport)
            })
            tableRows = [...groupSummaryReport]
            totalRecords = totalCount
          } catch (error) {
            handleServerError(error)
          }
        }
        return {
          tableRows,
          totalRecords
        }
      }
      $scope.showReportDateFilter = e => {
        $scope.$emit('SHOW_REPORT_DATE_FILTER_EMIT', { event: e })
      }
      const handleServerError = response => {
        $scope.$emit('handleServerError', response)
      }
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestId: '',
          downloadRequestStatus: jobStatusType.INITIAL,
          downloadUrl: ''
        }
      }
      $scope.resetCurrentReportDownload()
      const retryCurrentReportDownload = async (
        signal = new AbortController()
      ) => {
        const requestTimeout = $q.defer()
        signal.addEventListener('abort', () => {
          requestTimeout.resolve()
        })
        $scope.downloadStatus.downloadRequestId = ''
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        const requestRetryBackOffIterator = new RequestRetryBackOffHelper(
          50,
          5,
          true,
          30
        ).getIterator()
        for await (const { attempts } of requestRetryBackOffIterator) {
          try {
            if (signal.aborted) break
            const queryParams = new URLSearchParams(
              attempts > 1
                ? {
                    downloadRequestId: $scope.downloadStatus.downloadRequestId,
                    organizationId: $rootScope.currentUserOrganization.id,
                    groupId: groupId
                  }
                : lastRequestQueryParams
            )
            ;['page', 'limit'].forEach(param => {
              queryParams.delete(param)
            })
            const requestJson = {
              method: 'GET',
              url:
                EDGE_BASEURL +
                '/summary-report-download?' +
                queryParams.toString(),
              timeout: requestTimeout
            }
            const response = await $http(requestJson)
            if (response.data) {
              const downloadRequestStatus = response.data.downloadStatus
              if (attempts === 1) {
                $scope.downloadStatus.downloadRequestId =
                  response.data.downloadRequestId
              }
              if (downloadRequestStatus) {
                $scope.downloadStatus.downloadRequestStatus = downloadRequestStatus
                if (
                  downloadRequestStatus === jobStatusType.COMPLETED ||
                  signal.aborted
                ) {
                  $scope.downloadStatus.downloadUrl = response.data.url
                  triggerDownload($scope.downloadStatus.downloadUrl)
                  break
                }
                if (downloadRequestStatus === jobStatusType.FAILED) {
                  throw new Error(response.data.status.error)
                }
              }
            }
          } catch (ex) {
            console.error(ex)
            $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            $scope.showMessageToast(ex.data.status.error)
            break
          }
          $scope.$apply()
        }
        $scope.$apply()
      }
      function triggerDownload (url) {
        const a = document.createElement('a')
        a.href = url
        a.download = ''
        a.style.display = 'none'
        document.body.appendChild(a)

        a.click()
        document.body.removeChild(a)
      }
      let previousDownloadRequestAbortController = new AbortController()
      $scope.downloadCurrentReport = () => {
        if (
          previousDownloadRequestAbortController &&
          !previousDownloadRequestAbortController.signal.aborted
        ) {
          previousDownloadRequestAbortController.abort()
        }
        previousDownloadRequestAbortController = new AbortController()
        retryCurrentReportDownload(
          previousDownloadRequestAbortController.signal
        )
      }
      $scope.exportReport = () => {
        if ($scope.ngSummaryReportTable.ngTableParams.data.length > 1) {
          return
        }
        $scope.ngSummaryReportTable.ngTableParams.settings().$loading = true
        const headers = {
          dashcamName: $translate('dashcamName'),
          distance: `${$translate('distance')} - ${UnitSystem.value(
            1,
            'km',
            '$l'
          )}`,
          maxSpeed:
            UnitSystem.current === 'imperial'
              ? `${$translate('maxSpeed')} - mph`
              : `${$translate('maxSpeed')} - km/h`,
          speedAlarms: $translate('speedAlarms'),
          dangerousDrivingAlarms: $translate('dangerousDrivingAlarms'),
          geoFenceAlarms: $translate('geoFenceAlarms')
        }
        const report = $scope.ngSummaryReportTable.ngTableParams.data.map(
          tableRow => {
            const distance = parseFloat(tableRow.distance)
              .toFixed(2)
              .toString()

            return {
              [headers.dashcamName]: tableRow.name || $scope.edge_name,
              [headers.distance]: distance,
              [headers.maxSpeed]: tableRow.maxSpeed,
              [headers.speedAlarms]: tableRow.SpeedLimit,
              [headers.dangerousDrivingAlarms]: tableRow.aggressiveEventsCount,
              [headers.geoFenceAlarms]: tableRow.GeoFence
            }
          }
        )
        $scope.ngSummaryReportTable.ngTableParams.settings().$loading = false
        return report
      }

      const getDistance = value => {
        if (UnitSystem.current === 'imperial' && value.units === 'miles') {
          return parseFloat(value.distance).toFixed(2)
        }
        return parseFloat(window.milesToKilometers(value.distance)).toFixed(2)
      }
      const getSpeed = (value, precision = 2) => {
        const isImperial = UnitSystem.current === 'imperial'
        const conversionFactor = isImperial ? 2.23694 : 3.6
        return parseFloat((value * conversionFactor).toFixed(precision))
      }
    }
  ])
